import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import './Privacy.css';

const Privacy = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="privacy-page">
      <Header />
      <main className="main-content">
        <div className="privacy-container">
          <div className="privacy-header">
            <h1 className="privacy-title">{t('privacyPolicy')}</h1>
            <p className="privacy-last-updated">
              {t('lastUpdated')}: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="privacy-content">
            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection1')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection1Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection2')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection2Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection3')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection3Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection4')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection4Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection5')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection5Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection6')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection6Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection7')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection7Text')}
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">{t('privacySection8')}</h2>
              <p className="privacy-paragraph">
                {t('privacySection8Text')}
              </p>
            </section>
          </div>

          <footer className="privacy-footer">
            <p className="privacy-copyright">© {currentYear} Quizzer - {t('allRightsReserved')}</p>
          </footer>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy; 